export const TOGGLE_FAVORITE_PROCESS = 'TOGGLE_FAVORITE_PROCESS';

export function toggleFavoriteProcess(processID) {
  return {
    type: TOGGLE_FAVORITE_PROCESS,
    processID
  };
}



// WEBPACK FOOTER //
// ./js/actions/storage.js